import React, { Component } from "react";
import { css } from "glamor";
import { dimensions, truncate } from "../../style";
import { borders, type } from "../../style";

const sizerStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  visibility: "hidden",
  height: 0,
  overflow: "scroll",
  whiteSpace: "pre"
};

const ellipsify = (addEllipsis) => {
  return addEllipsis ? truncate : null
}

const addInputStyle = style => {
  if (style === "mt-purple") {
    return {
      background: "transparent",
      color: "#CAB4FF",
      height: "inherit",
      fontSize: 24,
      fontFamily: "'PT Serif', serif",
      padding: 0,
      borderTop: 0,
      borderRight: 0,
      borderBottom: "1px dashed #979797",
      borderLeft: 0,
      ":focus": {
        borderTop: 0,
        borderRight: 0,
        borderBottom: "1px dashed #979797",
        borderLeft: 0,
        outline: "none"
      },
      "::placeholder": {
        fontStyle: "italic",
        color: "white",
        opacity: 0.5
      },
      [dimensions.SCREEN_MAX_XXS]: {
        fontSize: 22
      }
    };
  }
  else {
    // default style for input if no style type not provided
    return {
      boxSizing: 'content-box',
      padding: '0 15px',
      height: '38px',
      outline: 'none',
      borderRadius: '3px',
      transition: 'border-color 0.2s ease-in-out',
      background: "transparent",
      ...type.MD,
      ':focus': {
        border: borders.BRAND
      }
    }
  }
};

const calcInputWidthStyle = (inputWidth, maxWidth) => {
    if (maxWidth && inputWidth > maxWidth) {
        return maxWidth
    }
    else return inputWidth
}

class AutoSizeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputWidth: props.minWidth,
      maxInputWidth: props.maxWidth,
      mounted: false
    };
    this.inputRef = this.inputRef.bind(this);
    this.placeHolderSizerRef = this.placeHolderSizerRef.bind(this);
    this.sizerRef = this.sizerRef.bind(this);
    this.copyInputStyles = this.copyInputStyles.bind(this);
    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
    this.select = this.select.bind(this);
    this.highlightText = this.highlightText.bind(this);
  }

  componentDidMount() {
    this.setState({ mounted: true });
    if (this.props.isCounter) {
      this.focus();
    }
    this.copyInputStyles();
    this.updateInputWidth();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.inputWidth !== this.state.inputWidth) {
      if (typeof this.props.onAutosize === "function") {
        this.props.onAutosize(this.state.inputWidth);
      }
    }
    this.updateInputWidth();
  }

  componentWillUnmount() {
    this.setState({ mounted: false });
  }

  inputRef(el) {
    this.input = el;
  }

  placeHolderSizerRef(el) {
    this.placeHolderSizer = el;
  }

  sizerRef(el) {
    this.sizer = el;
  }

  copyInputStyles() {
    if (this.state.mounted || !window.getComputedStyle) {
      return;
    }
    const inputStyle = this.input && window.getComputedStyle(this.input);
    if (!inputStyle) {
      return;
    }
    const widthNode = this.sizer;
    widthNode.style.fontSize = inputStyle.fontSize;
    widthNode.style.fontFamily = inputStyle.fontFamily;
    widthNode.style.fontWeight = inputStyle.fontWeight;
    widthNode.style.fontStyle = inputStyle.fontStyle;
    widthNode.style.letterSpacing = inputStyle.letterSpacing;
    widthNode.style.textTransform = inputStyle.textTransform;
    if (this.props.placeholder) {
      const placeholderNode = this.placeHolderSizer;
      placeholderNode.style.fontSize = inputStyle.fontSize;
      placeholderNode.style.fontFamily = inputStyle.fontFamily;
      placeholderNode.style.fontWeight = inputStyle.fontWeight;
      placeholderNode.style.fontStyle = inputStyle.fontStyle;
      placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
      placeholderNode.style.textTransform = inputStyle.textTransform;
    }
  }

  updateInputWidth() {
    if (
      !this.state.mounted ||
      !this.sizer ||
      typeof this.sizer.scrollWidth === "undefined"
    ) {
      return;
    }
    if (
      !this.state.mounted ||
      !this.sizer ||
      typeof this.sizer.scrollWidth === "undefined"
    ) {
      return;
    }
    let newInputWidth;
    if (
      this.props.placeholder &&
      (!this.props.value ||
        (this.props.value && this.props.placeholderIsMinWidth))
    ) {
      newInputWidth =
        Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
    } else {
      newInputWidth = this.sizer.scrollWidth + 2;
    }
    if (newInputWidth < this.props.minWidth) {
      newInputWidth = this.props.minWidth;
    }
    if (newInputWidth > this.props.maxWidth) {
      newInputWidth = this.props.maxWidth;
    }
    if (newInputWidth !== this.state.inputWidth) {
      this.setState({
        inputWidth: newInputWidth
      });
    }
  }

  focus() {
    this.input.focus();
  }

  blur() {
    this.input.blur();
  }

  select() {
    this.input.select();
  }

  highlightText(e) {
    e.target.setSelectionRange(0, e.target.value.length);
  }

  render() {
    const {
      hasErrors,
      inputProps,
      placeholder,
      value,
      customInputStyle,
      addEllipsis
    } = this.props;
    const sizerValue = inputProps.value;

    const inputStyle = Object.assign({});
    inputStyle.width = calcInputWidthStyle(this.state.inputWidth, this.props.maxLength) + "px"
    inputStyle.color =
      hasErrors && value ? "rgb(204, 84, 84)" : inputStyle.color;

    return (
      <div {...css({display:"inline-block"})}>
        <input
          ref={this.inputRef}
          {...inputProps}
          {...css(
            inputStyle,
            ellipsify(addEllipsis),
            addInputStyle(customInputStyle) )}
        />
        <div ref={this.sizerRef} style={sizerStyle}>
          {sizerValue}
        </div>
        {placeholder ? (
          <div ref={this.placeHolderSizerRef} style={sizerStyle}>
            {placeholder}
          </div>
        ) : null}
      </div>
    );
  }
}

export default AutoSizeInput;



// WEBPACK FOOTER //
// ./src/components/common/AutoSizeInput.jsx